import { query } from '@utils/url';
import { addClass, removeClass } from '@utils/domUtils';

/* global KTUtil, KTLayoutContent */

export default class ConversationSidebar {
  static selectorString() {
    return '.ConversationSidebar';
  }

  render(node, props) {
    this.listItems = [...node.querySelectorAll('.message-user-item-link')];

    this.listItems.forEach(link => {
      link.setAttribute('data-url', link.getAttribute('href'));
      link.filterName = link.getAttribute('data-filter-name');
    });

    const filter = node.querySelector('[name="filter"]');
    filter.addEventListener('keydown', this.filterChanged.bind(this));
    filter.addEventListener('keyup', this.filterChanged.bind(this));
    filter.addEventListener('change', this.filterChanged.bind(this));

    // NOTE: initially filter list by query param `filter`
    const filterQuery = query('filter');
    if (filterQuery) {
      this.filterList(filterQuery);
    }

    // NOTE: initialize perfect scrollbar (see: https://github.com/utatti/perfect-scrollbar)
    this.scrollNode = node.querySelector('.scroll');
    this.conversationCard = document.querySelector('.ConversationCard');

    KTUtil.scrollInit(this.scrollNode, {
      mobileNativeScroll: true,
      desktopNativeScroll: false,
      resetHeightOnDestroy: true,
      handleWindowResize: true,
      // TODO: remember position: does not seem to work: check and fix
      rememberPosition: true,
      height: () => {
        return this.getScrollHeight();
      },
    });

    setTimeout(this.loaded.bind(this), 170);
    setTimeout(this.loaded.bind(this), 340);
    window.addEventListener('load', this.loaded.bind(this));
  }

  getScrollHeight() {
    if (KTUtil.isBreakpointUp('lg')) {
      const layoutContentHeight = Math.max(
        KTLayoutContent.getHeight(),
        this.conversationCard ? this.conversationCard.offsetHeight : 0,
      );

      const spaceAround = this.node.offsetHeight - this.scrollNode.offsetHeight;

      return layoutContentHeight - spaceAround;
    }

    return null;
  }

  loaded() {
    this.setScrollHeight();
    setTimeout(this.setScrollHeight.bind(this), 170);
    setTimeout(this.setScrollHeight.bind(this), 340);
  }

  setScrollHeight() {
    this.scrollNode.style.height = `${this.getScrollHeight()}px`;
  }

  filterChanged() {
    const filterValue = this.node.querySelector('[name="filter"]').value;
    this.filterList(filterValue);
  }

  filterList(filterValue) {
    const lowerFilterValue = filterValue.toLowerCase();

    this.listItems.forEach(link => {
      link.setAttribute('href', `${link.getAttribute('data-url')}?filter=${filterValue}`);

      if (link.filterName.indexOf(lowerFilterValue) === -1) {
        addClass(link, 'hide');
      } else {
        removeClass(link, 'hide');
      }
    });
  }
}
